import React, { useEffect, useMemo, useState } from 'react';
import { withStyles } from '@material-ui/styles';
import Drawer from '@material-ui/core/Drawer';
import { compose } from 'redux';
import { connect } from 'react-redux';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import LoadingIcon from 'mdi-react/LoadingIcon';
import NotificationSystem from 'rc-notification';
import { getContact, updateContact } from 'redux/actions/contactActions';
import ContactUpdateForm from 'components/contact/ContactUpdateForm';
import BasicNotification from 'components/Notification';
import DialogTitle from 'components/modals/DialogTitle';
import { MIN_DESKTOP_WIDTH, NOTIFICATION_NODE_STYLE } from 'constants/misc';
import { transformContactCustomFieldToFormField, transformContactsCustomField } from 'utils/contact';


const ContactUpdateDrawer = ({
  classes,
  contact,
  contactId,
  sequenceId,
  sequenceContactId,
  isContactEditModalOpen,
  toggleContactEditModal,
  onUpdate,
  ...props
}) => {
  const [notification, setNotification] = useState(null);

  useEffect(() => {
    NotificationSystem.newInstance({}, n => setNotification(n));
    return () => (notification ? notification.destroy() : null);
  }, []);

  useEffect(() => {
    if (contactId) {
      props.getContact(contactId, { sequence_id: sequenceId });
    }
  }, [contactId, sequenceId]);

  const contactValues = useMemo(() => transformContactCustomFieldToFormField(contact), [contact.custom_field]);

  const showSuccessNotifcation = () => (
    notification.notice({
      content: <BasicNotification
        color="success"
        message="Contact updated successfully."
      />,
      duration: 2,
      style: NOTIFICATION_NODE_STYLE,
      className: 'alert--colored right-up',
    })
  );

  const handleSubmit = async (formData) => {
    const updatingContact = formData;
    if (sequenceContactId) {
      updatingContact.sequence_contact = sequenceContactId;
      transformContactsCustomField([updatingContact]);
    } else {
      delete updatingContact.custom_field;
    }
    await props.updateContact(contactId, updatingContact);
    showSuccessNotifcation();
    toggleContactEditModal();
    onUpdate();
  };

  return (
    <Drawer
      anchor="right"
      open={isContactEditModalOpen}
      onClose={toggleContactEditModal}
    >
      <DialogTitle className={classes.title}>
        Contact Edit
        <CloseRoundedIcon onClick={toggleContactEditModal} classes={{ root: classes.closeIcon }} />
      </DialogTitle>
      <div className={classes.formContainer}>
        {contact.loading ?
          <div className="loader"><LoadingIcon /></div> :
          <ContactUpdateForm
            onSubmit={handleSubmit}
            onCancel={toggleContactEditModal}
            showCustomField={!!sequenceContactId}
            initialValues={contactValues}
            {...props}
          />
        }
      </div>
    </Drawer>
  );
};

const styles = () => ({
  title: {
    textAlign: 'left',
    margin: '1rem',
  },
  formContainer: {
    width: 500,
    [`@media screen and (max-width: ${MIN_DESKTOP_WIDTH}px)`]: {
      width: '100%',
    },
  },
  closeIcon: {
    position: 'absolute',
    right: '0.875rem',
    width: '1.375rem',
    opacity: '0.2',
    cursor: 'pointer',
    '&:hover': {
      opacity: '0.5',
    },
  },
});

export default compose(
  withStyles(styles),
  connect(
    state => ({ contact: state.contact }),
    { getContact, updateContact },
  ),
)(ContactUpdateDrawer);
